import React from "react";
import Navbar from "../../common/Navbar/Navbar";
import Main from "./Main";

function AddAlert() {
  return (
    <div>
      <Navbar>
        <Main />
      </Navbar>
    </div>
  );
}

export default AddAlert;
